import styled, { css, keyframes } from "styled-components";


const slideLeftKeyframes = keyframes`
  from{
    transform: translateX(500px);
  }to{
    transform: translateX(0);
  }
`

const slideRightKeyframes = keyframes`
  from{
    transform: translateX(-500px);
  }to{
    transform: translateX(0);
  }
`

export const slideLeft = css`
  animation: ${slideLeftKeyframes} .2s forwards;
`

export const slideRight = css`
  animation: ${slideRightKeyframes} .2s forwards;
`

interface IProps {
  direction?: string;
}


export const AnimationContainer = styled.div<IProps>`
  ${({ direction }) => direction === 'right' ? slideRight :
    direction === 'left' ? slideLeft : ''
  } 
`

export const Title = styled.h1`
  font-size: 2.475rem;
  font-weight: 400;
  text-align: center;
  font-family: Roboto;
  color: #002445;

  &:after{
    content: "";
    width: 100%;
    height: 2px;
    display: block;
    margin: 15px 0 0px;
    background: ${props => props.theme.colors.silverBG};
  }
`


export const Link = styled.a`
  color: ${props => props.theme.colors.primary};
  font-weight: 500;
  font-size: .75rem;
  :hover{
    cursor: pointer;
  }
`